import { RootState } from "../rootReducer";

export const selectIsChangingPassword = (state: RootState) =>
  state.changePassword.loading;
export const selectIsSaved = (state: RootState) => state.changePassword.saved;
export const selectChangePasswordErrorMessage = (state: RootState) =>
  state.changePassword.error;
export const ChangePasswordDataResponse = (state: RootState) =>
  state.changePassword.changePasswordResponse;
